import api from "@/config/api"
import { withLoading } from "@/store/helpers"
import { toRaw } from "vue"

const extractDefaultFilters = (state) => {
  return {
    filters: {
      search: state.filters.search,
      team_ids: toRaw(state.filters.team_ids),
      blocked: state.filters.blocked
    },
    pagination: {
      page: state.pagination.page,
      per_page: state.pagination.per_page
    }
  }
}

export default {
  namespaced: true,
  state: () => ({
    users: [],
    filters: {
      search: "",
      team_ids: [],
      blocked: false,
    },
    pagination: {
      page: 1,
      per_page: 20,
    },
    loading: false,
  }),
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setFilters(state, payoad) {
      state.filters = payoad
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchUsers(context) {
      withLoading(async () => {
        const params = extractDefaultFilters(context.state)

        try {
          const response = await api.get("/manage/users", { params })
          context.commit("setUsers", response.data)
        } catch (error) {
          // Отказ загрузки — пустой список: экран показывает
          // «Пользователи не найдены» вместо таблицы с одной шапкой.
          context.commit("setUsers", [])
        }
      }, context)
    },

    async updateUser(context, { id, ...rest }) {
      withLoading(async () => {
        const params = { ...extractDefaultFilters(context.state), ...rest }
        const response = await api.put(`/manage/users/${id}`, params)
        context.commit("setUsers", response.data)
      }, context)
    },

    async block(context, { id, ...rest }) {
      withLoading(async () => {
        const params = { ...extractDefaultFilters(context.state), ...rest }
        const response = await api.put(`/manage/users/${id}/block`, params)
        context.commit("setUsers", response.data)
      }, context)
    },

    async unblock(context, { id, ...rest }) {
      withLoading(async () => {
        const params = { ...extractDefaultFilters(context.state), ...rest }
        const response = await api.put(`/manage/users/${id}/unblock`, params)
        context.commit("setUsers", response.data)
      }, context)
    }
  }
}
